import { render, staticRenderFns } from "./AppPhoneInput.vue?vue&type=template&id=8318315c&scoped=true&"
import script from "./AppPhoneInput.vue?vue&type=script&lang=ts&"
export * from "./AppPhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./AppPhoneInput.vue?vue&type=style&index=0&id=8318315c&lang=scss&scoped=true&"
import style1 from "./AppPhoneInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8318315c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
